import {
  Box,
  Button,
  Drawer,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import close from "../../../assets/svg/drawer_close.svg";
import { useToastMessages } from "../../../lib/messages/useToastMessages";
import { createShippingService } from "./shippingService.helper";
import { useDispatch } from "react-redux";
import { setShippingServiceState } from "../../../store/shippingServiceSlice";
// Only import useDispatch if you need to update Redux after save (optional)

export default function EditPriceWeight({ open, onClose, rates, bookedWeight, availableWeight, shippingId, id }) {
  const [booked, setBooked] = useState("");
  const [available, setAvailable] = useState("");
  const [priceInputs, setPriceInputs] = useState([]);
  const toast = useToastMessages();
  const dispatch = useDispatch();

  // Prefill fields when drawer opens or props change
  React.useEffect(() => {
    if (open) {
      setBooked(bookedWeight || "");
      setAvailable(availableWeight || "");
      if (Array.isArray(rates) && rates.length > 0) {
        setPriceInputs(rates.map(rate => rate.pricePerLb || ""));
      } else {
        setPriceInputs([]);
      }
    }
  }, [open, rates, bookedWeight, availableWeight]);

  const handlePriceChange = (idx, value) => {
    setPriceInputs(prev => {
      const updated = [...prev];
      updated[idx] = value;
      return updated;
    });
  };

  const handleSave = async () => {
    if (!id) return;
    const newRates = (Array.isArray(rates) ? rates : []).map((rate, idx) => ({
      ...rate,
      pricePerLb: Number(priceInputs[idx]) || 0,
    }));
    try {
      const response = await createShippingService({
        id: id,
        bookedWeight: Number(booked) || 0,
        availableWeight: Number(available) || 0,
        rates: newRates,
      });
      dispatch(setShippingServiceState({
        id: id,
        bookedWeight: Number(booked) || 0,
        availableWeight: Number(available) || 0,
        rates: newRates,
      }));
      toast.Success('Shipping service updated successfully!');
      onClose();
    } catch (err) {
      toast.Error('Failed to update shipping service.');
      console.error('Failed to update shipping service:', err);
    }
  };
  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{ sx: { background: "rgba(0, 0, 0, 0.5)" } }}
    >
      <Box sx={{ width: "500px" }}>
        <Box
          sx={{
            borderBottom: "1px solid #E5E5E8",
            paddingLeft: "20px",
            paddingTop: "20px",
            paddingBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" component="h5">
            Edit Price & Weight
          </Typography>
          <Box
            sx={{ paddingRight: "20px", cursor: "pointer" }}
            onClick={onClose}
          >
            <img src={close} alt="close" />
          </Box>
        </Box>
        <Box sx={{ minHeight: "84vh", borderBottom: "1px solid #E5E5E8" }}>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Weight
            </Typography>
            <Typography
              sx={{ marginTop: 2 }}
              variant="body1"
              fontWeight="normal"
            >
              Booked Weight
            </Typography>
            <Box>
              <FormControl
                sx={{
                  m: 1,
                  minWidth: 270,
                  minHeight: "35px",
                  marginLeft: "0px",
                }}
                size="small"
              >
                <OutlinedInput
                  name="merchantIndicator"
                  value={booked || ''}
                  onChange={(e) => setBooked(e.target.value)}
                />
              </FormControl>
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Typography variant="body1" fontWeight="normal">
              Available Weight
            </Typography>
            <Box>
              <FormControl
                sx={{
                  m: 1,
                  minWidth: 270,
                  minHeight: "35px",
                  marginLeft: "0px",
                }}
                size="small"
              >
                <OutlinedInput
                  name="merchantIndicator"
                  value={available || ''}
                  onChange={(e) => setAvailable(e.target.value)}
                />
              </FormControl>
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Price
            </Typography>
            {/* Dynamic price fields */}
            {Array.isArray(rates) && rates.length > 0 ? (
              rates.map((rate, idx) => (
                <Box key={idx}>
                  <Typography sx={{ marginTop: 2 }} variant="body1" fontWeight="normal">
                    {rate.minWeight}lb - {rate.maxWeight === 9999 ? 'above' : `${rate.maxWeight}lb`}
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minWidth: 270,
                      minHeight: "35px",
                      marginLeft: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      value={priceInputs[idx] || ''}
                      onChange={e => handlePriceChange(idx, e.target.value)}
                      startAdornment={<InputAdornment position="start">$</InputAdornment>}
                    />
                  </FormControl>
                </Box>
              ))
            ) : (
              <Typography sx={{ marginTop: 2 }} variant="body2" color="text.secondary">
                No price ranges available.
              </Typography>
            )}
          </Box>
        </Box>
        <Button
          type="submit"
          variant="contained"
          sx={{
            minWidth: "189px",
            position: "absolute",
            bottom: 20,
            right: 20,
            borderRadius: "4px",
          }}
          onClick={handleSave}
        >
          Save
        </Button>
      </Box>
    </Drawer>
  );
}
